<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ประวัติการใช้งานเครดิต</h1>
                    <p class="text-white pb-3 px-3">สรุปการใช้งานเครดิตของคุณ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-12">
                                    <b-form-group id="input-group-1"
                                                  label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)"
                                                  label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-3">
                                                <date-range-picker class="w-100" :opens="'center'"
                                                                   @start-selection="logEvent('startSelection', $event)"
                                                                   @finish-selection="logEvent('finishSelection', $event)"
                                                                   :min-date="minDate" :max-date="maxDate"
                                                                   :singleDatePicker="false"
                                                                   :appendToBody="true" :ranges="false"
                                                                   :closeOnEsc="false"
                                                                   :autoApply="true"
                                                                   :locale-data="{ format: 'dd-mm-yyyy' }"
                                                                   v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res"
                                                        @click="funcHistoryTopUpWallet()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0"/>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                class="scroll-bar-pop"
                                empty-text="ไม่มีรายละเอียดการใช้งานเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="dataUsegeWallet"
                                :fields="fields"
                                :busy="busy"
                                show-empty
                                responsive
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">
                                    {{ (pagination.currentPage - 1) * pagination.perPage + data.index + 1 }}
                                </template>
                                <template slot="operating" slot-scope="data">
                                    <button class="btn btn-sm btn-info px-3" @click="detail(data.item)">
                                        <i class="fas fa-file-alt"></i>รายละเอียด
                                    </button>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination :total-rows="pagination.totalItem" :current-page="pagination.currentPage"
                                              :per-page="pagination.perPage" :value="pagination.currentPage"
                                              @input="changePage"
                                              align="right">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <b-modal
            centered
            hide-footer
            v-model="detailVisible"
            size="lg"
            hide-header
            v-if="detailVisible"
        >
            <div class="row">
                <div class="col-12">
                    <span class="close cursor-pointer" @click="closeModal()">&times;</span>
                </div>
            </div>
            <div class="mt-1">
                <b-table
                    class="scroll-bar-pop"
                    empty-text="ไม่มีรายละเอียดการใช้งานเครดิต"
                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                    :items="newdataUsegeWallet"
                    :fields="isDiff ? newfields1 : newfields"
                    show-empty
                    responsive
                >
                    <div slot="table-busy" class="text-center">
                        <BlockUI>
                            <div class="loader"></div>
                        </BlockUI>
                    </div>
                    <template slot="type" slot-scope="data" v-if="isDiff">
                        {{ diffServerType.find(item => item.id === data.item.type).name }}
                    </template>
                </b-table>
            </div>
            <div class="mt-1">
                <b-pagination :total-rows="newpage.total" :current-page="newpage.pageIndex"
                              :per-page="newpage.pageSize" :value="newpage.pageIndex"
                              @input="newchangePage"
                              align="right">
                </b-pagination>
            </div>
        </b-modal>
    </div>
</template>
<script>
import moment from "moment";
import 'moment-timezone/builds/moment-timezone-with-data';
import {
    statusPaymentSubject,
    statusPayment,
    rowClass,
    rowClassTransaction,
    checkStatusRefNo2,
} from "@/axios/walletPayment.js"
import {dateLimitRanges} from "@/plugins/datePicker.js"

import Mixins from "./report_makeup";
import {billflow, getPageByBillId} from "@/api/topUp";

export default {
    mixins: [Mixins],

    name: "historyusagewallet",
    data() {
        return {
            isDiff: false,
            newfields: [
                {key: "createTime", label: "เวลาสร้าง", sortable: true, class: "text-center"},
                {key: "expressPkgNum", label: "เลขพัสดุ", class: "text-center", sortable: true},
                {key: "agentPayFee", label: "รายการเดินบัญชี", sortable: true, class: "text-center"},
            ],
            newfields1: [
                {key: "createTime", label: "เวลาสร้าง", sortable: true, class: "text-center"},
                {key: "expressPkgNum", label: "เลขพัสดุ", class: "text-center", sortable: true},
                {key: "expressCode", label: "บริษัทขนส่ง", sortable: true, class: "text-center"},
                {key: "type", label: "ประเภทบริการ", sortable: true, class: "text-center"},
            ],
            diffServerType: [
                {
                    id: 0,
                    name: 'ค่าขนส่ง'
                },
                {
                    id: 1,
                    name: 'ค่าธรรมเนียมCOD'
                },
                {
                    id: 2,
                    name: 'ค่าพื้นที่ห่างไกล'
                },
                {
                    id: 3,
                    name: 'ค่าบริการอื่นๆ'
                },
                {
                    id: 4,
                    name: 'ค่าธรรมเนียมCOD'
                }
            ],
            newdataUsegeWallet: [],
            detailVisible: false,
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: "",
                endDate: "",
            },
            filter: null,
            filterStatus: null,
            dataStatus: [
                {key: null, title: 'ดูประเภทรายการทั้งหมด'},
                {key: 'deposit', title: 'เติมเครดิต'},
                // { key: 'REFUND' , title: 'คืนเครดิตสาขา' },
                {key: 'withdraw', title: 'ค่าขนส่ง'}
            ],
            dataUsegeWallet: [],
            pagination: {
                totalPage: 1,
                totalItem: 0,
                currentPage: 1,
                perPage: 10,
            },
            statusPaymentSubject: statusPaymentSubject,
            statusPayment: statusPayment,
            rowClass: rowClass,
            rowClassTransaction: rowClassTransaction,
            checkStatusRefNo2: checkStatusRefNo2,

            funcHistoryTopUpWallet: null,
            funcGetDataBranceExportExcel: null,

            fields: [
                {key: "index", label: "ลำดับ", sortable: true},
                {key: "type", label: "ประเภทบิล", sortable: true, class: "text-center"},
                {key: "billNo", label: "หมายเลขบิล", sortable: true, class: "text-center"},
                {key: "createTime", label: "เวลาสร้าง", sortable: true, class: "text-center"},
                {key: "amount", label: "รายการเดินบัญชี", class: "text-center", sortable: true},
                {key: "balance", label: "ยอดเงินคงเหลือ", sortable: true, class: "text-center"},
                {key: "operating", label: "ดำเนินการ", sortable: true, class: "text-center"}
            ],
            newpage: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    filters: {
        dateFormat(date, use_walletV2) {
            if (use_walletV2) {
                // UTC to +07:00
                return moment(date, "YYYY-MM-DD HH:mm:ss")
                    .add(7, 'hours')
                    .format("DD/MM/YYYY HH:mm:ss");
            }

            return moment(date, "YYYY-MM-DD HH:mm:ss")
                .format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.getDateNow(new Date())
        this.historyUsageWallet()
    },
    methods: {
        closeModal() {
            this.detailVisible = false
        },
        detail(item) {
            if (item.billType === '0#2') {
                this.isDiff = true
            } else {
                this.isDiff = false
            }
            getPageByBillId({
                pageIndex: 1,
                pageSize: 10,
                billId: item.billNo
            }).then(res => {
                console.log(res)
                this.newdataUsegeWallet = res.data.records
                this.newpage.total = res.data.total
                this.detailVisible = true
            })
        },
        getDateNow(myDate) {
            // 当前日期
            var year = myDate.getFullYear();
            var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
            var date = ("0" + myDate.getDate()).slice(-2);
            var formattedDate = year + "-" + month + "-" + date;

            // 前一个月的同一天
            var lastMonthDate = new Date(myDate);
            lastMonthDate.setMonth(myDate.getMonth() - 1);

            // 处理跨年问题
            if (myDate.getMonth() === 0) {
                lastMonthDate.setFullYear(myDate.getFullYear() - 1);
                lastMonthDate.setMonth(11);
            }

            var lastMonthYear = lastMonthDate.getFullYear();
            var lastMonthMonth = ("0" + (lastMonthDate.getMonth() + 1)).slice(-2);
            var lastMonthDay = ("0" + lastMonthDate.getDate()).slice(-2);
            var formattedLastMonthDate = lastMonthYear + "-" + lastMonthMonth + "-" + lastMonthDay;

            // 设置时间区间
            this.filters.startDate = formattedLastMonthDate;
            this.filters.endDate = formattedDate;
        },
        logEvent(event, date) {
            const {minDate, maxDate} = dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        newchangePage(i) {
            if (this.newpage.pageIndex == i) {
                return
            }
            this.newpage.pageIndex = i
            this.detail()
        },
        changePage(i) {
            if (this.pagination.currentPage == i) {
                return
            }
            this.pagination.currentPage = i

            this.historyUsageWallet()
        },

        historyUsageWallet() {
            this.busy = true;
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")

            billflow({
                startTime: dateStart,
                endTime: dateEnd,
                pageIndex: this.pagination.currentPage,
                pageSize: this.pagination.perPage,
                billRechargeId: this.filter
            }).then(res => {
                console.log(res)
                let data = res.data;
                console.log(data, 123)
                this.dataUsegeWallet = data.records
                this.pagination.totalPage = data.total
                this.pagination.totalItem = data.total
                this.busy = false;
            }).catch(() => {
            });
        },
    }
};
</script>
